import { render, staticRenderFns } from "./MonsterReader.vue?vue&type=template&id=4f1df858"
import script from "./MonsterReader.vue?vue&type=script&lang=js"
export * from "./MonsterReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1df858')) {
      api.createRecord('4f1df858', component.options)
    } else {
      api.reload('4f1df858', component.options)
    }
    module.hot.accept("./MonsterReader.vue?vue&type=template&id=4f1df858", function () {
      api.rerender('4f1df858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/monster/MonsterReader.vue"
export default component.exports